











































import type { PropType } from '@vue/composition-api';
import { onMounted, computed, defineComponent } from '@vue/composition-api';
import type { ChatParticipant } from '@getaccept/dsr-shared';
import { ChatHelper, SidebarPlacement } from '@getaccept/dsr-shared';
import { storeToRefs } from 'pinia';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType } from '@getaccept/lib-ui';
import ChatListItem from '@getaccept/dsr-shared/src/chat/components/ChatListItem.vue';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { useParticipantsStore } from '../../store/participants.store';
import { useChatPublishedStore } from '../store/chat-published.store';
import ChatWrapper from './ChatWrapper.vue';

export default defineComponent({
  name: 'Chat',
  components: {
    ChatWrapper,
    ChatListItem,
  },
  props: {
    loaded: {
      type: Boolean,
    },
    recipientId: {
      required: true,
      type: String,
    },
    owner: {
      type: Object as PropType<User>,
      default: () => ({} as User),
    },
  },
  setup(props) {
    const participantsStore = useParticipantsStore();
    const { recipients } = storeToRefs(participantsStore);
    const {
      chat,
      lastGeneralChatMessage,
      handleSetCurrentConversation,
      setCreatingNewConversation,
      setTypingStatus,
      setDefaultConversation,
    } = useChatPublishedStore();

    const { creatingNewConversation } = storeToRefs(useChatPublishedStore());

    const participants = computed(() => {
      const filteredRecipients: ChatParticipant[] = recipients.value
        .filter(recipient => recipient.id !== props.recipientId)
        .map(recipient => ({ recipient, recipientId: recipient.id }));
      return [...filteredRecipients, { user: props.owner, userId: props.owner.id }];
    });

    const orderedConversations = computed(() =>
      ChatHelper.orderConversations([...chat.conversations])
    );

    const handleChangeConversation = (conversationId: string) => {
      setTypingStatus(false);
      handleSetCurrentConversation(conversationId);
    };

    onMounted(() => {
      setCreatingNewConversation(false);
      setDefaultConversation();
    });

    return {
      creatingNewConversation,
      recipients,
      lastGeneralChatMessage,
      chat,
      participants,
      handleChangeConversation,

      handleSetCurrentConversation,
      setCreatingNewConversation,
      orderedConversations,
      SidebarPlacement,
      t,
      ButtonType,
    };
  },
});
